import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { Amplify } from 'aws-amplify';
import outputs from '../amplify_outputs.json';
import { fetchAuthSession } from 'aws-amplify/auth';

Amplify.configure(outputs);
await fetchAuthSession({ forceRefresh: true });

Amplify.configure(outputs);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
